import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import { FormValidation } from "../FormValidation";
import { requiredField } from "../helpers";
import ErrorField from "./ErrorField";

const StudiosConsentField = ({
  form,
  disableForm,
  onFormChange,
  fieldStatus,
  submitButtonClicked,
  formIsSubmitted
}) => {
  const { trans } = useTrans();

  const title = trans("Studios consent");

  const subtitle = (
    <>
      <div className="subtitle">
        {/* prettier-ignore */ trans("I wish for my Wattys submission to be considered by WWS for future opportunities, including WWS prizes for this years Watty Awards.")}
        <br />
        <br />
        <strong>
          {/* prettier-ignore */ trans("You are NOT required to agree to this question. If you do not wish to be considered for WWS opportunities, please select No.")}
        </strong>
      </div>
    </>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "studiosConsent" &&
        fieldStatus.fieldName !== "" &&
        submitButtonClicked)) &&
    form.studiosConsent === "";

  const dropdownValue = formIsSubmitted
    ? form.studiosConsent // if the form is submitted, display the value of the studiosConsent field
      ? "yes"
      : "no"
    : form.studiosConsent === "" // otherwise, if the form is not submitted
      ? "" // a value of "" is the default value so show the placeholder
      : form.studiosConsent // or if the value is a boolean show the corresponding Yes / No value
        ? "yes"
        : "no";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation validationRules={[requiredField(trans)]}>
        {({ ref, errorMessage, className }) => (
          <>
            <select
              id="studios-consent-select"
              ref={ref}
              value={dropdownValue}
              name="studiosConsent"
              disabled={disableForm}
              className={classNames("form-element", className)}
              onChange={onFormChange}
              aria-label={trans("Select an option")}
            >
              <option value="" disabled>
                {trans("Select an option")}
              </option>
              <option key={"yes"} value={"yes"}>
                {trans("Yes")}
              </option>
              <option key={"no"} value={"no"}>
                {trans("No")}
              </option>
            </select>
            <ErrorField
              errorMessage={errorMessage}
              errorCondition={errorCondition}
              fieldId={"studios-consent"}
            />
          </>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

StudiosConsentField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitButtonClicked: PropTypes.bool.isRequired,
  formIsSubmitted: PropTypes.bool.isRequired
};

export default StudiosConsentField;
